import LogoutDialog from 'components/AppDialogs/LogoutDialog'
import UploadPage from 'components/Mobile/UploadPage'
import { useRootLoaderData } from 'components/Root.loader'
import TrailDateCheck from 'components/TrialDate'
import Version from 'components/Version'

const Mobile = () => {
  const rootData = useRootLoaderData()

  return (
    <>
      {rootData && <UploadPage />}
      <Version />
      <TrailDateCheck />
      <LogoutDialog />
    </>
  )
}

export default Mobile
